import * as React from 'react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { IFrameWindow } from '../../../../configuration/types';
import { getAccountsAndCurrentAccount, showSettingsDialog } from '../../appSlice';
import {
    pageLogout,
    pageRedirect,
    sendComponentLoaded,
    sendMessageToIFrameWrapper,
    showDialog,
} from '../../../common/iFrameHelper';
import { config } from '../../../../config';
import { redirectToLogout } from '../../../../configuration/login/logout';
import { fetchAccountsThunk } from '../../thunks';
import { ContactButton } from '../ContactButton/ContactButton';
import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks';
import { getIdTokenInfo } from '../../../../configuration/tokenHandling/tokenHandlingSlice';

export const PopoverContent: React.FC = () => {
    const { firstName, lastName, userName, subject } = useAppSelector(getIdTokenInfo);

    // TODO: should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization
    const { currentAccount, accounts } = useAppSelector(getAccountsAndCurrentAccount);

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(fetchAccountsThunk());
    }, [dispatch, subject]);

    const broadcastLogout = () => {
        if ('parentIFrame' in window) {
            const logoutURI = config.backend.LOGOUT_URI
                ? config.backend.LOGOUT_URI
                : 'https://auth.iam.rio.cloud/logout';
            sendMessageToIFrameWrapper(pageRedirect(logoutURI));
            sendMessageToIFrameWrapper(pageLogout()); // compatibility with old component
        } else {
            redirectToLogout();
        }
    };

    (window as IFrameWindow).iFrameResizer = {
        readyCallback: () => {
            if ('parentIFrame' in window) {
                sendComponentLoaded();
            }
        },
    };

    const renderUserDetails = () => {
        return (
            <div data-cy={'user-details'} className={'padding-bottom-10 text-color-dark line-height-125rel'}>
                <div className={'margin-bottom-5 text-bold text-size-16'}>
                    <strong>{`${firstName} ${lastName}`}</strong>
                </div>
                <div className={'margin-bottom-5 text-medium text-size-12'}>{currentAccount?.name}</div>
                <div className={'text-italic text-size-12'}>{userName}</div>
            </div>
        );
    };

    const internalShowSettingsDialog = () => {
        if ('parentIFrame' in window) {
            sendMessageToIFrameWrapper(showDialog());
        } else {
            dispatch(showSettingsDialog());
        }
    };

    const internalShowDialogSwitchAccountsTab = () => {
        if ('parentIFrame' in window) {
            sendMessageToIFrameWrapper(showDialog(2));
        } else {
            dispatch(showSettingsDialog(2));
        }
    };

    const renderProfileAndSettingsBtn = () => {
        return (
            <button
                className={'btn btn-link btn-link-inline line-height-btn'}
                onClick={internalShowSettingsDialog}
                tabIndex={0}
                data-cy={'dialog-profile-btn'}
            >
                <span className={'rioglyph rioglyph-rio margin-right-5 text-size-large'} />
                <FormattedMessage id={'intl-msg:popover.link.profile'} />
            </button>
        );
    };

    const renderSwitchAccountBtn = () => {
        return (
            <button
                className={'btn btn-link btn-link-inline line-height-btn'}
                onClick={internalShowDialogSwitchAccountsTab}
                tabIndex={0}
                data-cy={'dialog-accounts-btn'}
            >
                <span className={'rioglyph rioglyph-compare margin-right-5 text-size-large'} />
                <FormattedMessage id={'intl-msg:popover.link.switchAccount'} />
            </button>
        );
    };

    const renderLogOutBtn = () => {
        return (
            <button
                className={'btn btn-link btn-link-inline line-height-btn text-color-dark'}
                onClick={broadcastLogout}
                tabIndex={1}
                data-cy={'logout-btn'}
            >
                <span className={'rioglyph rioglyph-off margin-right-5 text-size-large text-color-dark'} />
                <FormattedMessage id={'intl-msg:popover.logout'} />
            </button>
        );
    };

    return (
        <div className={'popover-content margin-0 padding-0'}>
            {renderUserDetails()}
            <hr className={'margin-top-5 margin-bottom-5'} />
            <ul className={'list-unstyled'}>
                <li>{renderProfileAndSettingsBtn()}</li>
                {accounts.length > 1 ? <li>{renderSwitchAccountBtn()}</li> : <></>}
                <li>
                    <ContactButton />
                </li>
                <hr className={'margin-top-5 margin-bottom-5'} />
                <li>{renderLogOutBtn()}</li>
            </ul>
        </div>
    );
};
